/**
 * @Author:      jiang.weiwei
 * @DateTime:    2017-12-06 20:13:08
 * @Description: 个人稿库Js
 */
'use strict';

angular
    .module('pgcPersonalLibraryModule', [
        'editPageModule', //ugc新建 编辑
        'editVideoModule', // ugc视频新建编辑
        'imageTextModule', //pgc图文新建
        'atlasModule', //pgc图集新建
        'videoModule', //pgc视频
        'activityModule', //pgc活动
        'pgcManuscriptDetailsModule', //稿件详情
        'selectChannelModule', //稿件编辑页面的选择渠道的公共业务组件
        'persinalLibrary', // 公共js
    ])
    .controller('pgcPersonalLibraryCtrl', [
        '$scope',
        'httpService',
        '$filter',
        'modalDialog',
        'trsspliceString',
        '$q',
        '$timeout',
        '$state',
        function ($scope, httpService, $filter, modalDialog, trsspliceString, $q, $timeout, $state) {
            initStatus();
            initData();
            /**
             * [initStatus description] 初始化参数
             */
            function initStatus() {
                $scope.status = {
                    statusOptions: '',
                    channelsOptions: [],
                    articleTypeMap: {
                        //不同稿件的编辑页路由集合
                        0: 'imagetext',
                        1: 'atlas',
                        2: 'video',
                        3: 'activity'
                    },
                    detailPageMap: {
                        //不同稿件的详情页路由集合
                        0: 'imagetextdetail',
                        1: 'atlasdetail',
                        2: 'videodetail',
                        3: 'pgcmanuscriptdetails'
                    }
                };
                $scope.data = {
                    listData: [],
                    keywords: '', //检索的关键词
                    selectedArray: [] //选中的数据
                };
                $scope.articleStatus = {
                    0: '未提交',
                    1: '已退稿'
                    /*2: '已投稿',*/
                };
                $scope.articleType = {
                    0: '图文稿',
                    1: '图集稿',
                    2: '视频稿',
                    3: '活动稿'
                };
                $scope.page = {
                    CURRPAGE: 0,
                    PAGESIZE: 12,
                    ITEMCOUNT: 0
                };
                initDropDownList();
                addChildRefresh();
            }
            /**
             * [addChildRefresh description] 监听子页面保存，并刷新本身
             */
            function addChildRefresh() {
                window.addEventListener(
                    'storage',
                    function (e) {
                        if (e.key === 'ls.refresh') {
                            requestData();
                        }
                    },
                    false
                );
            }

            function initData() {
                initChannelsList().then(function (data) {
                    requestData();
                });
            }
            /**
             * [initDropDownList description] 初始化下拉菜单
             * @return {[type]} [description]
             */
            function initDropDownList() {
                $scope.status.statusOptions = [
                    {
                        name: '稿件状态',
                        value: ''
                    },
                    {
                        name: '未提交',
                        value: 0
                    },
                    {
                        name: '已退稿',
                        value: 1
                    }
                ];
                $scope.status.selectedStatus = angular.copy($scope.status.statusOptions[0]);
            }

            function initChannelsList() {
                var deferred = $q.defer();
                httpService.http('/mcnww/web/channel/querySignChnlList.do', '', 'get').then(function (data) {
                    var item = data.data;
                    var allchannel = {
                        name: '发布渠道',
                        value: ''
                    };
                    $scope.status.channelsOptions.push(allchannel);
                    for (var i = 0; i < item.length; i++) {
                        var creatJSON = {};
                        creatJSON.name = item[i].channelName;
                        creatJSON.value = item[i].id;
                        $scope.status.channelsOptions.push(creatJSON);
                    }
                    $scope.status.selectedChannel = angular.copy($scope.status.channelsOptions[0]);
                    deferred.resolve(data);
                });
                return deferred.promise;
            }
            /**
             * [requestData description] 初始化列表数据
             */
            $scope.requestData = function () {
                requestData();
            };

            function requestData() {
                $scope.data.selectedArray = [];
                var params = {
                    articleStatus: $scope.status.selectedStatus.value,
                    pubChannelId: $scope.status.selectedChannel.value,
                    startTime: $scope.status.startDate,
                    endTime: $scope.status.endDate,
                    searchWord: $scope.data.keywords,
                    currPage: $scope.page.CURRPAGE,
                    pageSize: $scope.page.PAGESIZE
                };
                $scope.loadingPromise = httpService.http('/mcnww/web/pgcArticle/unPubList.do', params, 'get').then(function (data) {
                    $scope.data.listData = data.data.ldata;
                    $scope.page = {
                        CURRPAGE: data.data.startPage,
                        PAGESIZE: data.data.pageSize,
                        ITEMCOUNT: data.data.totalResults,
                        PAGECOUNT: data.data.totalPages
                    };
                });
            }
            /**
             * [dateFormat description] 时间格式化
             * @return {[type]} [description]
             */
            $scope.dateFormat = function (item) {
                item.newTime = $filter('date')(item.operTime, 'yyyy-MM-dd HH:mm:ss').toString();
            };
            /**
             * [queryByDropdown description] 筛选条件触发后请求数据
             * @param  {[type]} key   [description] 请求对象参数key
             * @param  {[type]} value [description] 请求对象值
             * @return {[type]}       [description] null
             */
            $scope.queryByDropdown = function () {
                // $scope.params.startTime = $scope.status.startDate;
                // $scope.params.endTime = $scope.status.endDate;
                requestData();
            };
            /**
             * [fullTextSearch description;全文检索]
             * @param  {[type]} ev [description:按下回车也能提交]
             */
            $scope.fullTextSearch = function (ev) {
                if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                    // $scope.params.searchWord = $scope.data.keywords;
                    requestData();
                }
            };
            /**
             * [selectDoc description] 单选
             * @param  {[type]} item [description] 当前数据
             * @return {[type]}      [description]
             */
            $scope.selectDoc = function (item) {
                var index = $scope.data.selectedArray.indexOf(item);
                index > -1 ? $scope.data.selectedArray.splice(index, 1) : $scope.data.selectedArray.push(item);
            };
            /**
             * [selectPanel description] 全选当前面板的稿件
             * @param  {[type]} items [description] 当前面板
             * @return {[type]}       [description]
             */
            $scope.selectPanel = function (items) {
                if ($scope.data.listData.length > 0 && $scope.data.selectedArray.length == $scope.data.listData.length) {
                    $scope.data.selectedArray = [];
                } else {
                    $scope.data.selectedArray = [].concat($scope.data.listData);
                }
            };
            /**
             * [deleteList description;删除稿件]
             * @param  {[type]} id
             */
            $scope.deleteList = function () {
                modalDialog.confirmModal('删除', '确认删除选中稿件吗？', function () {
                    var params = {
                        // 'articleIds': ''
                    };
                    multipleId($scope.data.selectedArray, params);
                    httpService.http('/mcnww/web/pgcArticle/delPersonalArticles.do', params, 'get').then(function (data) {
                        requestData();
                    });
                });
            };
            /**
             * [release description;发布]
             * @param  {[type]} id
             */
            $scope.release = function (item) {
                modalDialog.confirmModal('发布', '确认发布选中的稿件？', function () {
                    var params = {
                        // 'articleIds':''
                    };
                    if (!item) {
                        multipleId($scope.data.selectedArray, params);
                    } else {
                        params.articleIds = item.id;
                    }
                    httpService.http('/mcnww/web/pgcArticle/pubPGCArticles.do', params, 'get').then(function (data) {
                        requestData();
                    });
                });
            };

            /**
             * [multipleId description;判读多个id]
             * @param  {[type]} 选中元素的集合
             */
            function multipleId(items, params) {
                if (items.length > 1) {
                    var newIds = [];
                    for (var i = 0; i < items.length; i++) {
                        newIds.push(items[i].id);
                    }
                    params.articleIds = newIds.join(',');
                } else {
                    params.articleIds = trsspliceString.spliceString(items, 'id', ',');
                }
            }
            /**
             * [pageChanged description]分页请求
             * @return {[type]} [description]
             */
            $scope.pageChanged = function () {
                // $scope.params.currPage = $scope.page.CURRPAGE;
                // $scope.status.jumpToPageNum = $scope.page.CURRPAGE;
                requestData();
            };
            /**
             * [getLogin description] 获取登入详细
             * @return {[type]} [description]
             */
            getLogin();

            function getLogin() {
                httpService.http('/mcnww/web/user/getLoginUser.do', '', 'post').then(function (data) {
                    /*$scope.signChannels = data.signChannels.length;
            if(data.auditStatus ==1||data.auditStatus ==3){
            	$scope.adddisabled  = true;
            }*/
                    $scope.btnAddIsDisabled = data.signChannels.length > 0 && (data.auditStatus == 1 || data.auditStatus == 3);
                });
            }
        }
    ]);
